import React from 'react';
import { Link } from 'react-router-dom';

function UseCases() {
  return (
    <div className="page-container">
      <div className="section-title">
        <h1>Use Cases</h1>
        <p>Three situations that make lawyers uncomfortable</p>
      </div>

      <div id="hostile-discovery" className="card mb-4">
        <h2>Evidence That Survives Hostile Discovery</h2>
        <p>
          <strong>Scenario:</strong> Opposing counsel aggressively challenges every piece
          of evidence. They claim documents have been altered, timestamps are fabricated,
          and chain of custody is broken.
        </p>
        <p>
          <strong>Solution:</strong> Evidencer provides cryptographic proof of authenticity.
          Each piece of evidence is fingerprinted at upload with SHA-256 hashing. Any
          alteration would produce a different fingerprint, making tampering immediately
          detectable.
        </p>
        <p>
          <strong>Legal Standard:</strong> Meets Federal Rules of Evidence 901
          (Authentication) and 902(14) (Self-Authenticating Evidence).
        </p>
        <Link to="/evidence" className="btn btn-primary mt-2">
          Upload Evidence →
        </Link>
      </div>

      <div id="media-integrity" className="card mb-4">
        <h2>Media That Disproves Alteration Claims</h2>
        <p>
          <strong>Scenario:</strong> You submit video or photo evidence. Defense claims
          it's been manipulated using editing software. Without proof of integrity,
          your critical evidence may be excluded.
        </p>
        <p>
          <strong>Solution:</strong> Evidencer creates an immutable fingerprint of media
          files at the time of upload. The original fingerprint is stored in tamper-evident
          storage. Any changes to the file produce a different fingerprint.
        </p>
        <p>
          <strong>Result:</strong> You can prove the current file matches the original
          fingerprint, demonstrating no alteration has occurred.
        </p>
        <Link to="/evidence" className="btn btn-primary mt-2">
          Verify Media →
        </Link>
      </div>

      <div id="chain-of-custody" className="card mb-4">
        <h2>Chain-of-Custody No Human Can Fake</h2>
        <p>
          <strong>Scenario:</strong> Evidence passes through multiple parties: police,
          forensic labs, attorneys, expert witnesses. Each transfer must be documented.
          A single gap can invalidate the evidence.
        </p>
        <p>
          <strong>Solution:</strong> Evidencer automatically records every custody transfer
          with cryptographic attestation. Transfers are logged with timestamps and cannot
          be backdated or forged. The complete chain is always available for audit.
        </p>
        <p>
          <strong>Benefit:</strong> Unbreakable chain of custody that withstands
          adversarial scrutiny. Compliance with EDRM best practices.
        </p>
        <Link to="/evidence" className="btn btn-primary mt-2">
          Track Custody →
        </Link>
      </div>

      <div className="cta mt-8 text-center">
        <h2>Ready to Secure Your Evidence?</h2>
        <p>Start verifying evidence in seconds. No complex setup required.</p>
        <Link to="/evidence" className="btn btn-primary btn-large">
          Get Started →
        </Link>
      </div>
    </div>
  );
}

export default UseCases;
